import { cmsCLient } from '@/services/axiosConfig'
import { DigitalConsentData } from './types'

export type GetDigitalConsentDataRes = DigitalConsentData

export type GetDigitalConsentData = () => Promise<GetDigitalConsentDataRes>

export const getDigitalConsentData: GetDigitalConsentData = async () => {
  try {
    const response = await cmsCLient.get('/digital-consent')
    return response.data.data.attributes
  } catch (e: any) {
    return e.message
  }
}
